import { Outlet } from "react-router-dom";
import MainStatsPage from "./Stats";

export const adminStatsRoutes = [
  {
    path: "stats",
    element: Outlet,
    children: [
      {
        path: "",
        element: MainStatsPage,
      },
    ],
  },
];
